(function () {
  var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  var cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart';

  function updateCount() {
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(function () {});
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  }

  function notify(title) {
    var tpl = document.getElementById('AddedNotification');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-product-title', title || '');
    document.body.appendChild(node);
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.classList || !form.classList.contains('lb-add')) return;
    evt.preventDefault();

    var btn = form.querySelector('.lb-add__btn');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

    var data = new FormData(form);
    data.delete('return_to');

    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          if (btn) {
            btn.textContent = res.body.description || 'Unavailable';
            btn.disabled = false;
            setTimeout(function () { btn.textContent = label; }, 2500);
          }
          return;
        }
        updateCount();
        refreshDrawer();
        notify(res.body.product_title || res.body.title || '');
        if (btn) {
          btn.textContent = 'Added';
          btn.classList.add('lb-add__btn--added');
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
            btn.classList.remove('lb-add__btn--added');
          }, 2000);
        }
      })
      .catch(function () { form.submit(); });
  });
})();
/* 29.09.26: sticky bars and the Redeemly "Rewards" launcher.
   body.lb-atc-visible: the product page sticky Add to Cart bar is showing. (The old check also needed the bar to
   lose its "invisible" class, which nothing ever removes, so the class was never added and the launcher was never moved.)
   body.lbcp-bar-on: the cart page sticky Checkout bar is showing (set by lb-cart.js).
   On phones, while either bar shows, the launcher is lifted above it (bar height + 12px, smooth). The launcher's markup
   comes from the Redeemly app, so it is found at runtime: an element with "redeemly" in its id, class, tag or iframe src,
   or a small fixed "Rewards" button near the bottom of the screen. Only its outermost position:fixed box is moved. */
(function () {
  var GAP = 12;
  var RX = /redeemly/i;
  var atc = null, cartBar = null, launchers = [], scanT = 0, raf = 0;
  var phone = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
  var canTranslate = !!(window.CSS && CSS.supports && CSS.supports('translate', '0 0'));

  function atcShowing() {
    return !!atc && !atc.classList.contains('sticky-atc--out')
      && !document.body.classList.contains('scrolled-to-bottom')
      && atc.offsetHeight > 0;
  }
  function syncAtc() {
    document.body.classList.toggle('lb-atc-visible', atcShowing());
    schedule();
  }
  function activeBar() {
    var b = document.body;
    if (atc && b.classList.contains('lb-atc-visible') && phone && phone.matches) return atc;
    if (cartBar && b.classList.contains('lbcp-bar-on')) return cartBar;
    return null;
  }
  function isOurs(el) {
    return !!(el.closest && el.closest('sticky-atc, [data-lbcp-bar], cart-drawer, .cart-drawer, #cart-drawer, .section-header, .lb-hs-sheet'));
  }
  function fixedRoot(el) {
    var found = null, n = el;
    while (n && n.nodeType === 1 && n !== document.body && n !== document.documentElement) {
      if (getComputedStyle(n).position === 'fixed') found = n;
      n = n.parentElement;
    }
    return found;
  }
  function looksLikeLauncher(el) {
    if (getComputedStyle(el).position !== 'fixed') return false;
    var r = el.getBoundingClientRect(), vh = window.innerHeight, vw = window.innerWidth;
    if (!r.height || r.height > 160 || r.width > Math.min(vw * 0.8, 360) || r.bottom < vh * 0.6) return false;
    var t = (el.textContent || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.shadowRoot ? el.shadowRoot.textContent || '' : '');
    return /reward/i.test(t);
  }
  function add(root) {
    if (!root || isOurs(root) || launchers.indexOf(root) !== -1) return;
    launchers.push(root);
  }
  function scan() {
    scanT = 0;
    launchers = launchers.filter(function (l) { return l.isConnected; });
    var list = document.body.querySelectorAll('[id*="redeemly" i], [class*="redeemly" i], iframe[src*="redeemly" i], iframe[title*="redeemly" i], iframe[name*="redeemly" i]');
    for (var i = 0; i < list.length; i++) add(fixedRoot(list[i]));
    /* custom element tags (e.g. <redeemly-launcher>) and unnamed fixed "Rewards" buttons: body children, 3 levels deep */
    (function walk(parent, depth) {
      var kids = parent.children;
      for (var k = 0; k < kids.length; k++) {
        var el = kids[k];
        if (/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|TEMPLATE)$/.test(el.tagName) || el.id === 'content' || el.tagName === 'MAIN') continue;
        if (RX.test(el.tagName)) add(fixedRoot(el) || (getComputedStyle(el).position === 'fixed' ? el : null));
        else if (looksLikeLauncher(el)) add(el);
        if (depth < 3) walk(el, depth + 1);
      }
    })(document.body, 1);
    schedule();
  }
  function scheduleScan() { clearTimeout(scanT); scanT = setTimeout(scan, 300); }
  function schedule() { if (!raf) raf = requestAnimationFrame(apply); }

  function prepTransition(l) {
    if (l.__lbRdmT) return;
    l.__lbRdmT = 1;
    var cs = getComputedStyle(l), cur = cs.transition || '';
    var none = !cur || /^all 0s/.test(cur) || cs.transitionDuration.split(',').every(function (d) { return parseFloat(d) === 0; });
    l.style.setProperty('transition', none ? 'translate .25s ease' : cur + ', translate .25s ease');
  }
  function apply() {
    raf = 0;
    var bar = activeBar();
    var vh = window.innerHeight;
    document.body.classList.toggle('lb-rdm-up', !!bar);
    for (var i = 0; i < launchers.length; i++) {
      var l = launchers[i];
      if (!l.isConnected) continue;
      var lifted = parseFloat(l.getAttribute('data-lb-rdm') || '0') || 0;
      var r = l.getBoundingClientRect();
      /* distance from the launcher's resting bottom edge to the bottom of the screen; measured while not lifted and settled */
      if (!lifted && r.height && Date.now() - (l.__lbRdmAt || 0) > 350) l.__lbRdmGap = Math.max(0, vh - r.bottom);
      var big = r.height > 160 || r.width > Math.min(window.innerWidth * 0.8, 360); /* rewards panel open: leave it alone */
      var lift = 0;
      if (bar && !big && l.__lbRdmGap != null) lift = Math.max(0, Math.round(bar.offsetHeight + GAP - l.__lbRdmGap));
      if (lift === lifted) continue;
      l.__lbRdmAt = Date.now();
      l.setAttribute('data-lb-rdm', String(lift));
      if (canTranslate) {
        prepTransition(l);
        if (lift) l.style.setProperty('translate', '0 ' + (-lift) + 'px', 'important');
        else l.style.removeProperty('translate');
      } else {
        /* older browsers: hide it while the bar shows */
        if (lift) l.style.setProperty('visibility', 'hidden', 'important');
        else l.style.removeProperty('visibility');
      }
    }
  }

  function init() {
    atc = document.querySelector('sticky-atc');
    cartBar = document.querySelector('[data-lbcp-bar]');
    if (!atc && !cartBar) return;
    if (atc) new MutationObserver(syncAtc).observe(atc, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () {
      if (atc) document.body.classList.toggle('lb-atc-visible', atcShowing());
      schedule();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    /* watch the whole page for the launcher for the first 20s (apps inject it late), then only body's direct children */
    var mo = new MutationObserver(scheduleScan);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); mo.observe(document.body, { childList: true }); }, 20000);
    window.addEventListener('resize', function () {
      launchers.forEach(function (l) { if (!parseFloat(l.getAttribute('data-lb-rdm') || '0')) l.__lbRdmGap = null; });
      schedule();
    });
    if (phone && phone.addEventListener) phone.addEventListener('change', schedule);
    if (atc) syncAtc();
    scan();
    window.addEventListener('load', scheduleScan, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();